module.exports = __webpack_public_path__ + "static/media/kaipiaoliucheng.05656dbc.png";